var DataItem = /*#__PURE__*/function () {
  function DataItem(data) {
    if (data === void 0) {
      data = undefined;
    }

    this.data = data;
  }

  var _proto = DataItem.prototype;

  _proto.isActive = function isActive() {
    return true;
  };

  _proto["export"] = function _export() {
    return this.data;
  };

  return DataItem;
}();

export { DataItem as default };


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/fedops-logger/dist/es/src/data-items/common/data-item.js
// module id = 41
// module chunks = 0 1